import { getTestAttributes } from '@chillibean/component-library';

import { dateFormat, isValidDate } from '../dates';

const generateStaticColumns = (options = {}) => {
  const staticColumnsOne = [
    { Header: 'Trial Name', accessor: 'trial_name' },
    { Header: 'Trial ID', accessor: 'trial_id' },
    { Header: 'Library/Site Name', accessor: 'library_name' },
    { Header: 'Library/Site ID', accessor: 'library_id' },
  ];

  if (options.sitesEnabled) {
    staticColumnsOne.push({ Header: 'Subject', accessor: 'subject' });
    staticColumnsOne.push({ Header: 'Study Event', accessor: 'study_event' });
    staticColumnsOne.push({ Header: 'Study Procedure', accessor: 'study_procedure' });
    staticColumnsOne.push({ Header: 'Evaluator', accessor: 'evaluator' });
  }

  const staticColumnsTwo = [
    { Header: 'Asset ID', accessor: 'asset_id' },
    { Header: 'Asset Title', accessor: 'asset_title', formatting: false },
    { Header: 'Upload Date', accessor: 'created_at' },
    { Header: 'Uploaded By', accessor: 'uploaded_by' },
    { Header: 'Info Fields', accessor: 'info_fields' },
    { Header: 'Comments', accessor: 'comments' },
    { Header: 'Reviewed By', accessor: 'reviewed_by' },
    { Header: 'Reviewed Date', accessor: 'reviewed_date' },
    { Header: 'File Size', accessor: 'filesize' },
    { Header: 'Asset Link', accessor: 'asset_link' },
    { Header: 'Forms', accessor: 'forms' },
  ];

  return [...staticColumnsOne, ...staticColumnsTwo];
};

const prepareColumnHeaders = (data, accountInfoFields, options = {}) => {
  const headers = [];
  const columns = generateStaticColumns({ sitesEnabled: options.sitesEnabled });

  columns.forEach((col) => {
    if (col.accessor === 'info_fields') {
      // each row has the same info fields
      accountInfoFields.forEach((infoField, index) => {
        headers.push({
          infoFieldIndex: index,
          Header: infoField.name,
          accessor: infoField.key,
          formatting: infoField.type === 'date',
          noTime: true,
        });
      });
    } else {
      headers.push({
        ...col,
        accessor: col.accessor,
        formatting: col.formatting !== undefined ? col.formatting : true,
      });
    }
  });

  return headers;
};

const isValidUrl = (urlString) => {
  try {
    return Boolean(new URL(urlString));
  } catch (e) {
    return false;
  }
};

const formatValue = (rawValue, assetEntry, formattingEnabled, noTime, accessor) => {
  if (accessor === 'asset_title')
    return (
      <a
        href={assetEntry.asset_link}
        {...getTestAttributes(`asset-${assetEntry.asset_id}-title`)}
        target="_blank"
        rel="noreferrer"
      >
        {rawValue}
      </a>
    );

  if (!rawValue || rawValue === '') return '-';

  if (!formattingEnabled || !Number.isNaN(Number(rawValue))) return rawValue;

  if (isValidDate(rawValue)) return dateFormat(rawValue, { withoutTime: noTime !== undefined && noTime });

  if (isValidUrl(rawValue))
    return (
      <a href={rawValue} {...getTestAttributes(`asset-${assetEntry.asset_id}-link`)} target="_blank" rel="noreferrer">
        {rawValue}
      </a>
    );

  return rawValue;
};

const prepareAssetRowData = (data, accountInfoFields, options = {}) => {
  const headersReadyForTable = prepareColumnHeaders(data, accountInfoFields, { sitesEnabled: options.sitesEnabled });
  const dataReadyForTable = [];
  data.forEach((assetEntry) => {
    const preparedRow = {};
    headersReadyForTable.forEach((header) => {
      const retrievedValue =
        assetEntry?.[header.accessor] ||
        assetEntry.info_fields.find((field) => {
          return field.key === header.accessor;
        })?.value;
      preparedRow[header.accessor] = formatValue(
        retrievedValue,
        assetEntry,
        header.formatting,
        header.noTime,
        header.accessor,
      );
    });
    dataReadyForTable.push(preparedRow);
  });
  return { dataReadyForTable, headersReadyForTable };
};

export default prepareAssetRowData;
